import React from 'react';
import * as R from 'ramda';
import styled from 'styled-components';
import { layout, flexbox } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Box, Flex } from '@cowsquare/design';

export const RowTitle = styled(Box).attrs({
  mb: 5,
})`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.33;
`;

const Row = styled(Box).attrs({
  display: ['block', 'flex'],
  mb: 5,
})`
  ${layout}
  ${flexbox}

  &:last-child {
    margin: 0;
  }
`;

const RowLabel = styled(Box).attrs({
  width: ['100%', 236],
  mb: [4, 0],
})`
  display: inline-block;
  font-size: ${themeGet('fontSizes.h5')};
  line-height: 1.43;
  color: ${themeGet('colors.blacks.5')};
`;

const PaymentRowLabel = styled(RowLabel).attrs({
  width: ['100%', 140],
})``;

const RowValue = styled(Box)`
  flex: 1;
  font-size: ${themeGet('fontSizes.h5')};
  line-height: 1.43;
`;

const RowImageWrapper = styled(Flex)`
  line-height: 1;

  img {
    width: 100%;
  }
`;

export const RowImage = ({ src, name }) => (
  <Box mb={5}>
    <RowImageWrapper flexDirection="row">
      {src && (
        <Box width="68px" mr={5}>
          <img src={src} alt="" />
        </Box>
      )}
      <span>{name}</span>
    </RowImageWrapper>
  </Box>
);

export const RowLink = styled.a`
  text-decoration: none;
  color: ${themeGet('colors.link')};
`;

export const RowMap = styled(Box).attrs({
  mt: 5,
})`
  width: 100%;
  height: 200px;
`;

export const Field = ({ label, value, render = R.identity, direction = 'row' }) =>
  !R.either(R.isEmpty, R.isNil)(value) ? (
    <Row flexDirection={direction}>
      <RowLabel>{label}</RowLabel>
      <RowValue ml={direction === 'row' ? [0, 5] : 0}>{render(value)}</RowValue>
    </Row>
  ) : null;

export const PaymentField = ({ label, value, render = R.identity }) =>
  !R.either(R.isEmpty, R.isNil)(value) ? (
    <Row>
      <PaymentRowLabel>{label}</PaymentRowLabel>
      <RowValue>{render(value)}</RowValue>
    </Row>
  ) : null;

export const generateRowValue = R.curry((path, render = R.identity) =>
  R.addIndex(R.map)((v, index) => <div key={index}>{R.pipe(R.pathOr('', path), render)(v)}</div>)
);
